import { render } from "./ReviewsSection.vue?vue&type=template&id=5c2db4b0&scoped=true"
import script from "./ReviewsSection.vue?vue&type=script&lang=js"
export * from "./ReviewsSection.vue?vue&type=script&lang=js"

import "./ReviewsSection.vue?vue&type=style&index=0&id=5c2db4b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2db4b0"]])

export default __exports__